export default {
      id: "Icon--locationPersonalMarker-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--locationPersonalMarker",
      toString: function () {
        return this.url;
      }
    }